import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import ConfirmModel from "./components/confirm";
import LoaderModel from "./components/loader";
import AlertModel from "./components/alert";

Vue.use(ConfirmModel);
Vue.use(LoaderModel);
Vue.use(AlertModel);

Vue.config.productionTip = false;
Vue.mixin({
  computed: {
    websiteType() {
      return this.$store.getters.type;
    },
  },
});
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
